import { useFeatureEnabled } from './useFeatureEnabled';

function useFeatureCreateReservationMemberPortal(): boolean {
  return useFeatureEnabled('CREATE_RESERVATION_V2_MP');
}

function useFeatureCreateReservationClientPortal(): boolean {
  return useFeatureEnabled('CREATE_RESERVATION_V2_CP');
}

function useFeatureCreateReservationF1(): boolean {
  return useFeatureEnabled('CREATE_RESERVATION_V2_F1');
}

export {
  useFeatureCreateReservationMemberPortal,
  useFeatureCreateReservationClientPortal,
  useFeatureCreateReservationF1,
};
